import type { CSSProperties, ReactNode } from 'react';

/** The large placeholder of an empty list or page: an icon, a heading, and what to do. */
export function EmptyState({ icon, title, children, style, testId }: { icon: ReactNode; title: ReactNode; children?: ReactNode; style?: CSSProperties; testId?: string }) {
  return (
    <div className="empty" style={style} data-testid={testId}><div className="empty-inner">
      <div className="empty-icon">{icon}</div>
      <h2>{title}</h2>
      {children}
    </div></div>
  );
}
